import React, { useEffect, useState, useRef } from 'react';
import cls from '@utils/css-select';
import styles from './styles.scss';
import Header from 'containers/landing/header';
import hostry from 'history';

import Section from 'components/section';
import useSelectData, { SelectType } from './useSelectData';
import { toast } from 'components/dialogs';

const cx = cls(styles);

export default function EnLandingHome(props: any) {
	const [detailMsg, setDetail] = useState<any>({});
	const selectData = useSelectData();
	useEffect(() => {
		window.scrollTo(0, 0);
		if (selectData.length) {
			const curItem = selectData.find((v: SelectType) => {
				return v.id === +props.match.params.id;
			});
			setDetail(curItem);
		}
	}, [selectData]);

	const handleCopy = () => {
		const oInput: HTMLInputElement = document.createElement('input');
		oInput.setAttribute('readonly', 'readonly');
		oInput.value = 'HR@air-class.com';
		document.body.appendChild(oInput);
		oInput.select();
		document.execCommand('Copy');
		oInput.style.display = 'none';
		oInput.remove();
		toast({
			message: 'Copied',
		});
	};

	return (
		<div className={cx('en-recurit-detail')}>
			<Header showRight={false} title="online tutoring" />
			<Section>
				<div className={cx('detail')}>
					<div className={cx('detail-intro')}>
						<span className={cx('name')}>{detailMsg.job}</span>
						<span className={cx('desc')}>
							{detailMsg.workType} | {detailMsg.department} | {detailMsg.country}
						</span>
					</div>
					<div className={cx('detail-container')}>
						<div className={cx('detail-row')}>
							<div className={cx('detail-container__title')}>What we offer you:</div>
							<div className={cx('detail-container__desc')} dangerouslySetInnerHTML={{ __html: detailMsg.welfare }}></div>
						</div>
						<div className={cx('detail-row')}>
							<div className={cx('detail-container__title')}>Job description:</div>
							<div className={cx('detail-container__desc')} dangerouslySetInnerHTML={{ __html: detailMsg.desc }}></div>
						</div>
					</div>
					<div className={cx('detail-contact')}>
						<div className={cx('detail-contact__msg')}>
							<p>
								Hi~If you are interested in us, AirClass 1-on-1, please email your CV to HR@air-class.com. We will reply within three
								working days.
							</p>
							<p> And the email needs several elements.</p>
							<p> Subject: Name+Apply position. </p>
							<p> Attachment: CV+Graduation Certificate+Degree Certificate+other certificates. Please apply and welcome to join us!</p>
						</div>
						<div className={cx('detail-contact__email')}>
							HR@air-class.com <span onClick={handleCopy}>Copy</span>
						</div>
					</div>
				</div>
			</Section>
		</div>
	);
}
